<template>
  <BaseDialog centered contentClass="task-template-dialog" ref="dialog" :show-actions="false" @opened="focusTitleInput">
    <template slot="title">
      {{
        isEditMode
          ? $t('page.admin-task-templates.edit-dialog.title')
          : $t('page.admin-task-templates.add-dialog.title')
      }}
    </template>
    <template slot="content">
      <form @click.prevent @keydown.enter.prevent>
        <div class="task-template-dialog__field">
          <FormInput
            ref="titleInput"
            v-model="form.title"
            hasGrayBackground
            :label="$t('page.admin-task-templates.add-dialog.name')"
          />
        </div>
        <div class="task-template-dialog__field">
          <FormInput
            v-model="form.description"
            hasGrayBackground
            name="task-description"
            is-textarea
            :label="$t('page.admin-task-templates.add-dialog.description')"
          />
        </div>
        <div class="task-template-dialog__actions">
          <FormButton is-outlined class="task-template-dialog__cancel" @click.native="cancelClick">
            {{ $t('actions.cancel') }}
          </FormButton>
          <FormButton @click.native="onSubmit" :disabled="!isFormValid" type="submit">
            <span>{{ isEditMode ? $t('actions.save') : $t('actions.create') }}</span>
          </FormButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import FormButton from '@/components/form/FormButton';
import FormInput from '@/components/form/FormInput';
import { mapActions } from 'vuex';

export default {
  name: 'TaskTemplateDialog',
  components: {
    FormButton,
    FormInput,
    BaseDialog,
  },
  data() {
    return {
      templateId: null,
      form: {
        title: '',
        description: '',
      },
    };
  },
  computed: {
    isEditMode() {
      return !!this.templateId;
    },
    isFormValid() {
      return !!this.form.title;
    },
  },
  methods: {
    ...mapActions('taskTemplates', ['createTaskTemplate', 'updateTaskTemplate']),
    openDialog(template) {
      if (template) {
        this.templateId = template.id;
        this.form.title = template.title || '';
        this.form.description = template.description || '';
      } else {
        this.templateId = null;
        this.form.title = '';
        this.form.description = '';
      }

      this.$refs.dialog.openModal();
    },
    focusTitleInput() {
      const input = this.$refs.titleInput && this.$refs.titleInput.$el.querySelector('input');
      if (input) input.focus();
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
    onSubmit() {
      if (!this.isFormValid) {
        return;
      }

      const payload = {
        title: this.form.title,
        description: this.form.description,
      };

      if (this.isEditMode) {
        payload.id = this.templateId;
        this.updateTaskTemplate(payload)
          .then(() => {
            this.$toast.success(this.$t('page.admin-task-templates.actions.success-update'));
            this.$emit('action-succeeded');
            this.closeDialog();
          })
          .catch(() => {
            this.$toast.error(this.$t('errors.genericError'));
          });
      } else {
        this.createTaskTemplate(payload)
          .then(() => {
            this.$toast.success(this.$t('page.admin-task-templates.actions.success-create'));
            this.$emit('action-succeeded');
            this.closeDialog();
          })
          .catch(() => {
            this.$toast.error(this.$t('errors.genericError'));
          });
      }
    },
    cancelClick() {
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
.base-dialog__task-template-dialog {
  height: auto;
  width: 600px;
  position: relative;

  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    background: $color-white !important;
  }

  .close-icon__container {
    display: none;
  }
}

.task-template-dialog {
  &__field {
    margin-bottom: 16px;
  }

  &__actions {
    margin-top: 32px;
    justify-content: flex-end;
    display: flex;
  }

  &__cancel {
    margin-right: 12px;
  }
}
</style>
